<template>
  <section class="mt-2">
    <template>
      <v-row class="ma-3">
        <v-autocomplete
          v-model="SelectedCountry"
          class="rounded me-2"
          dense
          outlined
          item-text="txt"
          item-value="val"
          :items="countryList"
          placeholder="Select Country"
        ></v-autocomplete>
        <v-btn
          depressed
          color="primary"
          class="text-capitalize me-3 mt-1"
          small
          @click="getAllratesData()"
        >
          Get Results
        </v-btn>
        <v-btn
          depressed
          @click="downloadExcelsheet"
          color="primary"
          small
          class="mt-1"
          ><v-icon small>mdi-file-excel-outline</v-icon>Export
        </v-btn>
        <v-btn
          depressed
          @click="getCTCRates()"
          color="primary"
          class="ms-2 mt-1"
          small
          ><v-icon small class="me-2">mdi-reload</v-icon>Sync Rates
        </v-btn>

        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Type here to filter the table data."
          single-line
          class="me-4 mx-2"
          dense
          clearable
        ></v-text-field>
      </v-row>
    </template>
    <v-dialog persistent max-width="400px" v-model="formDialogVisible">
      <v-card class="pb-3">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-toolbar color="grey lighten-3 font-weight-bold" flat dense>
            <span class="subtitleFontsize">Update Percentage</span>
            <v-spacer></v-spacer>
            <v-btn depressed icon @click="closeFormDialog()">
              <v-icon small>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text class="">
            <v-row>
              <v-col cols="12" md="12">
                <label class="my-0 labelFontsize required"> Percantage</label>
                <v-text-field
                  placeholder="Percnatage"
                  dense
                  type="number"
                  hide-spin-buttons
                  @keydown="validateNumber"
                  :rules="percentageRules"
                  v-model="updatedPercentage"
                  outlined
                  class="rounded"
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider class="mt-0"></v-divider>
          <v-btn
            depressed
            small
            color="primary"
            min-width="170px"
            @click="closeFormDialog()"
            class="text-capitalize me-3 ms-3"
            outlined
          >
            <v-icon small class="me-2">mdi-close-circle-outline</v-icon>Cancel
          </v-btn>
          <v-btn
            depressed
            small
            color="primary"
            min-width="170px"
            @click="updatePercenatge()"
            class="ms-3 text-capitalize"
          >
            Save
          </v-btn>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog persistent max-width="400px" v-model="ctcrateDialog">
      <v-card class="pb-3">
        <v-form ref="formccRate" v-model="validdata" lazy-validation>
          <v-toolbar color="grey lighten-3 font-weight-bold" flat dense>
            <span class="subtitleFontsize">Update CTC Rate</span>
            <v-spacer></v-spacer>
            <v-btn depressed icon @click="closectcrateDialog()">
              <v-icon small>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text class="">
            <!-- <v-row>
              <v-col cols="12">
                <v-chip color="primary" outlined label class="mb-2 m-auto">
                  {{ this.selectedRateData ? this.selectedRateData.units : null
                  }}{{ " "
                  }}{{
                    this.selectedRateData
                      ? this.selectedRateData.source_currency_cd
                      : null
                  }}
                  =
                  {{
                    this.selectedRateData
                      ? this.selectedRateData.cc_rate
                      : null
                  }}{{ " "
                  }}{{
                    this.selectedRateData
                      ? this.selectedRateData.destination_currency_cd
                      : null
                  }}
                </v-chip>
              </v-col>
            </v-row> -->
            <v-row>
              <v-col cols="12" md="12">
                <label class="my-0 labelFontsize required"> CTC Rate</label>
                <v-text-field
                  placeholder="Rate"
                  dense
                  type="number"
                  hide-spin-buttons
                  @keydown="validateNumber"
                  :rules="RateRules"
                  v-model="updatectcRate"
                  outlined
                  class="rounded"
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider class="mt-0"></v-divider>
          <v-btn
            depressed
            small
            color="primary"
            min-width="170px"
            @click="closectcrateDialog()"
            class="text-capitalize me-3 ms-3"
            outlined
          >
            <v-icon small class="me-2">mdi-close-circle-outline</v-icon>Cancel
          </v-btn>
          <v-btn
            depressed
            small
            color="primary"
            min-width="170px"
            @click="updateCTCrate()"
            class="ms-3 text-capitalize"
          >
            Save
          </v-btn>
        </v-form>
      </v-card>
    </v-dialog>
    <v-data-table fixed-header  height="55vh"
      :headers="headers"
      dense
      :search="search"
      class="p-1"
      :items-per-page="-1"
      :items="DashboardratesData"
      loading-text="Loading... Please wait"
      item-key="id"
    >
      <template v-slot:item.calc_rate="{ item }">
        <span>{{ item.calc_rate.toFixed(4) }}</span>
      </template>
      <template v-slot:item.destination_currency_cd="{ item }">
        <span
          >{{ item.destination_currency_cd }}<span class="ms-2 me-2">to</span
          >{{ item.source_currency_cd }}
        </span>
      </template>
      <template v-slot:item.source_currency_cd="{ item }">
        <span>{{ item.source_currency_cd }}</span>
      </template>
      <template v-slot:item.actions="{ item }">
        <div class="d-flex">
          <v-switch
            v-model="item.is_active"
            height="0px"
            color="success"
            dense
            @change="isactiveupdate(item)"
          ></v-switch>
        </div>
        <!-- <v-icon small color="primary" @click="deleteItem(item)">
              mdi-trash-can-outline
            </v-icon> -->
      </template>
      <template v-slot:item.cc_rate="{ item }">
        <span>
          <span class="me-1">{{ item.cc_rate }}</span
          ><v-icon @click="openctcrateDialog(item)" color="primary" small
            >mdi-content-save-edit-outline</v-icon
          >
        </span>
        <!-- <v-col cols="4" md="4" sm="4">
            <v-text-field
              placeholder="Percnatage"
              dense
              type="number"
              hide-spin-buttons
              :rules="percentageRules"
              v-model="item.cc_rate"
              outlined
              class="rounded"
            >
            </v-text-field>
          </v-col> -->
      </template>
    </v-data-table>

    <loading :active="loader" :opacity="0.9" color="#ff6b00" />
  </section>
</template>

<script>
import alerts from "@/mixins/alerts";
import { Masterdata } from "@/utils/validationCopy.js";
import Loading from "vue-loading-overlay";
import setupService from "@/services/SetupService/setupService";
import croneService from "@/services/CroneService/croneService";
import commonService from "@/services/CommonService/commonService.js";
import { validateNumber } from "@/utils/validate.js";
export default {
  name: "Addmastercat",
  mixins: [alerts],
  data() {
    return {
      ...Masterdata,
      validateNumber,
      valid: true,
      validdata: true,
      search: "",
      formDialogVisible: false,
      ctcrateDialog: false,
      rate_id: null,
      updatectcRate: null,
      DashboardratesData: [],
      updatedPercentage: null,
      singleSelect: false,
      selectedRateData: null,
      selectedItems: [],
      countryList: [],
      SelectedCountry: "MYS",
      postState: {
        name: "",
        state_code: "",
      },
      loader: false,
      percentageRules: [
        (v) => !!v || "Percentage is required",
        (v) => (v <= 5 && v > 0) || "Percentage range between 1 to 5",
      ],
      RateRules: [(v) => !!v || "Rate is required"],
      headers: [
        {
          text: "Currency",
          value: "source_currency_cd",
        },

        { text: "Description", value: "destination_currency_cd" },

        // { text: "Margin/Spread", value: "margin", sortable: false },
        // { text: "Percentage (%)", value: "percentage" },
        { text: "CTC Rate", value: "cc_rate" },
        { text: "Status", value: "actions" },
      ],
    };
  },
  props: {},
  components: {
    Loading,
  },
  mounted() {
    this.getActiveCountries();
  },
  computed: {
    showButton() {
      return this.selectedItems.length > 0;
    },
    allValuesSelected() {
      return this.selectedItems.length === this.DashboardratesData.length;
    },
  },
  methods: {
    async downloadExcelsheet() {
      if (this.DashboardratesData) {
        this.exportToExcel(
          this.headers,
          this.DashboardratesData,
          "Dashboard_rates"
        );
      }
    },
    updatePercenatge() {
      const validate = this.$refs.form.validate();
      if (validate) {
        console.log("data", this.selectedItems);
        this.selectedItems = this.selectedItems.map((ele) => ele.id);
        if (this.allValuesSelected) {
          this.updateAllrates();
        } else {
          this.updatefewSelcted();
        }
      }
    },
    stoploader() {
      setTimeout(() => {
        this.loader = false;
      }, 400);
    },
    openFormDialog() {
      this.updatedPercentage = null;
      this.formDialogVisible = true;
    },
    closeFormDialog() {
      this.formDialogVisible = false;
      this.updatedPercentage = null;
    },
    openctcrateDialog(item) {
      this.selectedRateData = item;
      this.updatectcRate = item.cc_rate;
      this.rate_id = item.id;
      this.ctcrateDialog = true;
    },
    closectcrateDialog() {
      this.updatectcRate = null;
      this.ctcrateDialog = false;
    },
    async getCTCRates() {
      try {
        const response = await croneService.getAllratesData(
          this.SelectedCountry
        );
        console.log(response);
      } catch (e) {
        console.error(e);
      }
      this.getAlltableratesData();
    },
    async getActiveCountries() {
      try {
        const responseData = await commonService.getparameterdropdowns("SCNT");
        if (responseData.data.status_code === 200) {
          this.countryList = responseData.data.data.map((i) => {
            return { txt: i.value, val: i.value_code };
          });
        }
      } catch (e) {
        console.error(e);
      }
    },
    async isactiveupdate(isactive) {
      this.loader = true;

      try {
        const responseData = await setupService.updateDashboardStatus(
          isactive.id,
          isactive.is_active,
          {}
        );
        console.log(`responseData: ${JSON.stringify(responseData)}`);
        setTimeout(() => {
          this.loader = false;
        }, 300);
        if (responseData && responseData.data.status_code == 200) {
          this.getAllratesData();
          this.showAlertSuccess(responseData.data.message);
        } else {
          this.showAlertError(responseData.data.message);
        }
        console.log("respose data", responseData);
      } catch (e) {
        console.log(e);
        this.showAlertError("Something went wrong please try again later.");
      }
      setTimeout(() => {
        this.loader = false;
      }, 400);
    },
    async updateCTCrate() {
      const validate = this.$refs.formccRate.validate();
      if (validate) {
        try {
          const responseData = await setupService.updateccrate({
            rate: this.updatectcRate,
            id: this.rate_id,
          });
          if (responseData && responseData.data.status_code == 200) {
            this.showAlertSuccess(`Rate Updated: ${responseData.data.message}`);
            this.getAllratesData();
            this.ctcrateDialog = false;
          }
          //  else if (responseData.data.status_code === 401) {
          //   this.returnNewToken();
          //   this.updateCTCrate();
          // }
          else {
            this.showAlertError(
              "Update Failed :" + " " + responseData.data.message
            );
          }
        } catch (e) {
          console.error(e);
          this.showAlertError("Something went wrong please try again later.");
        }
      }
    },
    getAllratesData() {
      this.getAlltableratesData();
    },
    async getAlltableratesData() {
      this.loader = true;
      try {
        const response = await setupService.getAllratesData(
          "IND",
          this.SelectedCountry
        );
        if (response.data.status_code === 200) {
          this.DashboardratesData = response.data.data.reverse();
          this.stoploader();
        }
      } catch (e) {
        console.error(e);
        this.DashboardratesData = [];
        this.loader = false;
      }
    },
    async getupdateCalculation() {
      this.loader = true;
      try {
        const response = await setupService.getupdateCalculation();
        if (response.data.status_code === 200) {
          this.getAllratesData();
          this.stoploader();
        }
      } catch (e) {
        console.error(e);
        this.loader = false;
      }
    },

    async updatefewSelcted() {
      try {
        const responseData = await setupService.updatePercentages(
          this.updatedPercentage,
          this.selectedItems
        );
        if (responseData && responseData.data.status_code == 200) {
          this.showAlertSuccess(
            `Percentage Updated: ${responseData.data.message}`
          );
          this.getupdateCalculation();
          this.formDialogVisible = false;
          this.selectedItems = [];
        }
        // else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.updatefewSelcted();
        //   this.selectedItems = [];
        // }
        else {
          this.showAlertError(
            "Update Failed :" + " " + responseData.data.message
          );
          this.selectedItems = [];
        }
      } catch (e) {
        console.error(e);
        this.selectedItems = [];
        this.showAlertError("Something went wrong please try again later.");
      }
    },
    async updateAllrates() {
      try {
        const responseData = await setupService.updateAllPercentages(
          this.updatedPercentage
        );
        if (responseData && responseData.data.status_code == 200) {
          this.showAlertSuccess(
            `Percentage Updated: ${responseData.data.message}`
          );
          this.getupdateCalculation();
          this.formDialogVisible = false;
          this.selectedItems = [];
        }
        // else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.updateAllrates();
        //   this.selectedItems = [];
        // }
        else {
          this.selectedItems = [];
          this.showAlertError("Update Failed :" + responseData.data.message);
        }
      } catch (e) {
        console.error(e);
        this.selectedItems = [];
        this.showAlertError("Something went wrong please try again later.");
      }
    },
  },
};
</script>

<style>
.required:after {
  content: " *";
  color: red;
}
</style>
